module.exports = __webpack_public_path__ + "static/media/buy_rating_3.915c8e50.jpg";